import { render } from "./InterestDemoStatistics.vue?vue&type=template&id=9674b038&scoped=true"
import script from "./InterestDemoStatistics.vue?vue&type=script&lang=js"
export * from "./InterestDemoStatistics.vue?vue&type=script&lang=js"

import "./InterestDemoStatistics.vue?vue&type=style&index=0&id=9674b038&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9674b038"]])

export default __exports__